<template>
  <v-container class="pa-0 ma-auto" fluid fill-height>
    <v-row class="fill-height ma-auto pa-0" align="center" justify="center">
      <BaseVideo
        v-if="media && media.type == 'video'"
        :filename="media.filename"
        :s3bucket="media.s3bucket"
        :thumbnail="thumbnail"
      ></BaseVideo>
      <YoutubeVideoComponent
        v-if="media && media.type == 'youtubevideo'"
        :youtube-code="media.youtube_code"
        :slot-width="slotWidth"
        :slot-height="slotHeight"
        :thumbnail="thumbnail"
      ></YoutubeVideoComponent>
      <BasePicture
        v-if="media && media.type == 'picture'"
        :filename="media.filename"
        :s3bucket="media.s3bucket"
        :original-width="media.width"
        :original-height="media.height"
        :slot-width="slotWidth"
        :slot-height="slotHeight"
        :keep-aspect-ratio="thumbnail ? false : true"
        :tooltip="tooltip(media)"
      ></BasePicture>
    </v-row>
  </v-container>
</template>

<script>
import YoutubeVideoComponent from '@/components/YoutubeVideoComponent.vue'
import BasePicture from '@/components/BasePicture.vue'
import BaseVideo from '@/components/BaseVideo.vue'

export default {
  props: {
    media: {
      type: Object
    },
    slotWidth: {
      type: Number,
      default: -1
    },
    slotHeight: {
      type: Number,
      default: -1
    },
    thumbnail: {
      type: Boolean,
      default: false
    }
  },

  components: {
    YoutubeVideoComponent,
    BasePicture,
    BaseVideo
  },

  methods: {
    tooltip(media) {
      if (media.id) {
        return media.id.toString()
      } else {
        return ''
      }
    }
  }
}
</script>

<style></style>
